// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"TextInputForm_wrapper_2ocA9","textInput":"TextInputForm_textInput_pPQ4h","sendBtn":"TextInputForm_sendBtn_3OaXT","upArrow":"TextInputForm_upArrow_bbht_","disabled":"TextInputForm_disabled_1S5Sk"};


//////////////////
// WEBPACK FOOTER
// ./src/components/TextInputForm/TextInputForm.css
// module id = 118
// module chunks = 0